import { call, options, params } from './helpers';

export const getCustomers = (payload) =>
	call(`/beta/admin/organizations${params(payload)}`);

export const getAllEvents = (payload) =>
	call(`/beta/admin/events${params(payload)}`);

export const getOrganization = (id) => {
	console.log('get :', id);
	return call(`/beta/admin/organization/${id}`);
};
export const updateOrganization = ({ id, ...payload }) => {
	console.log('ID: ', id, payload);
	return call(`/beta/admin/organization/${id}`, options(payload, 'PUT'));
};

export const getAllTasks = (payload) =>
	call(`/beta/admin/tasks${params(payload)}`);

export const getAllAdminServiceReports = (payload) =>
	call(`/beta/admin/service-reports${params(payload)}`);

export const createBlankAdminServiceReport = (payload) =>
	call(`/beta/admin/service-reports`, options(payload, 'POST'));

export const getAdminServiceReport = ({ id }) =>
	call(`/beta/admin/service-reports/${id}`);
export const updateAdminServiceReport = ({ id, ...payload }) =>
	call(`/beta/admin/service-reports/${id}`, options(payload, 'PUT'));

export const createAdminServiceBlocks = (payload) =>
	call(`/beta/admin/service-reports/blocks`, options(payload, 'POST'));

export const updateAdminServiceBlocks = ({ id, ...payload }) =>
	call(`/beta/admin/service-reports/blocks/${id}`, options(payload, 'PUT'));

export const deleteAdminServiceBlock = ({ id }) =>
	call(`/beta/admin/service-reports/blocks/${id}`, options(null, 'DELETE'));

export const getAllAdminServiceBlocks = (payload) =>
	call(`/beta/admin/service-reports/blocks${params(payload)}`);

export const betaCreateOrganization = (payload) =>
	call(`/beta/admin/initialize`, options(payload, 'POST'));

export const getAssetsAdmin = (id) =>
	call(`/beta/admin/organization/${id}/assets`);

export const getOrganizationUsers = (id) =>
	call(`/beta/admin/organization/${id}/users`);

export const getOrganizationServiceReports = (id) =>
	call(`/beta/admin/organization/${id}/service-reports`);

export const uploadServiceReportImages = ({ id, files }) =>
	call(
		`/beta/admin/service-reports/${id}/images`,
		options({ files, bucket: 'service-reports', information: {} }, 'POST'),
	);
